import { useTable, usePagination, useSortBy } from 'react-table';
import { style } from './Table.module.scss';

import { TertiaryButton } from '@component';

export const Table = function Table({ columns, data, actions, defaultSortBy = [] }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 25, sortBy: defaultSortBy },
    },
    useSortBy,
    usePagination
  );

  return (
    <div className={style}>
      <table {...getTableProps()} className="w-full">
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className={`text-black font-semi-bold ${column.isSorted ? 'sorted' : ''}`}
                >
                  {column.render('Header')}{' '}
                  {column.isSorted ? (
                    column.isSortedDesc ? (
                      <span>↑</span>
                    ) : (
                      <span>↓</span>
                    )
                  ) : null}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                })}
                {actions && <td>{actions(row)}</td>}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="pagination mt-4 flex justify-center">
        <TertiaryButton className="mr-4 text-primary" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          First
        </TertiaryButton>
        <TertiaryButton className="mr-4 text-primary" onClick={() => previousPage()} disabled={!canPreviousPage}>
          Previous
        </TertiaryButton>
        <div className="mr-4 text-primary-500">
          Page {pageIndex + 1} of {pageCount}
        </div>
        <TertiaryButton className="mr-4 text-primary" onClick={() => nextPage()} disabled={!canNextPage}>
          Next
        </TertiaryButton>
        <TertiaryButton className="mr-8 text-primary" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          Last
        </TertiaryButton>
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[25, 50, 100, 250, 500].map(size => (
            <option key={size} value={size}>
              Show {size}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
